import Icon, { SearchOutlined } from '@ant-design/icons';
import { noticeRelation, queryRelationNotice } from '@api/announcement';
import EmptyIcon from '@assets/image/empty.svg';
import LoudspeakerIcon from '@assets/image/loudspeaker.svg';
import ZeissButton from '@components/button';
import ZeissInput from '@components/input';
import ZeissModal from '@components/zeiss-modal';
import { ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { getDomianRelativeUrl } from '@utils/tool';
import {
  ActionTypeEnum,
  AnnouncementDetailDataInterface,
  AnnouncementGroupsItemInterface,
  GroupsNoticeItemInterface,
  NOTICE_SUCCESS_ARR
} from '@views/pages/AnnouncementDetails/type';
import { Col, Empty, Row, Tag, Tooltip, message } from 'antd';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import { caretSvg, noticeSvg, noticeTypeClassMap } from './data';
import './index.scss';
import TagsOverflow from './tagsOverflow';
import { AnnFooterPopup } from '../../Footer/Popup/annFooterPopup';

export const useRelatedAnnouncement = ({
  details = {} as AnnouncementDetailDataInterface,
  getAnnInfo,
  isFinishAction,
  isReturnAction,
  checkNeedOperation
}: any) => {
  const { groups, dataFlag } = details as AnnouncementDetailDataInterface;

  const [open, setOpen] = useState(false);
  const [currentNoticeObj, setCurrentNoticeObj] =
    useState<GroupsNoticeItemInterface | null>(null);
  const [currentGroupObj, setCurrentGroupObj] =
    useState<AnnouncementGroupsItemInterface | null>(null);
  const [relationActionType, setRelationActionType] = useState<ActionTypeEnum>(
    ActionTypeEnum.related
  );
  const [collapseItemsArr, setCollapseItemsArr] = useState<
    AnnouncementGroupsItemInterface[]
  >([]);
  const [emptyData, setEmptyData] = useState<AnnouncementGroupsItemInterface[]>(
    []
  );
  const inputFilterRef = useRef<any>(null);
  const [userInfos] = useRecoilState(userInfo);
  const [actionId, setActionId] = useState(-1); //3:转销售 2:转Sector同事 5:不相关 6:重复
  const [repeatOpen, setRepeatOpen] = useState(false);

  // const isDealer = userInfos.roleKeys === ROLE_KEYS_MAP.dealer;

  const subTitle = useMemo(() => {
    if (userInfos.roleKeys === ROLE_KEYS_MAP.sales) {
      return '';
    }
    return groups?.length
      ? '系统自动判断下方的公告与当前的公告属于同一个招标项目。如果当前公告与下方不属于同一个招标项目，请点击取消关联。'
      : '系统没有发现与本公告同一个招标项目下的其它公告。如果有的话，请关联前序公告，以避免重复创建项目。';
  }, [groups]);

  const gotoDetailPage = (data: GroupsNoticeItemInterface) => {
    const { noticeCode } = data;

    window.open(
      `${getDomianRelativeUrl()}/announcement/announcementDetail?noticeId=` +
        noticeCode
    );
  };

  const handleItemAction = (
    item: GroupsNoticeItemInterface,
    actionId: number
  ) => {
    // 如果是第一条公告，操作整组，否则只操作当前公告（整个判断逻辑在后端）
    setCurrentNoticeObj(item);
    setActionId(actionId);
    setRepeatOpen(true);
  };

  // 折叠面板展开的内容
  const collapseItemChildrenRender = (
    data: GroupsNoticeItemInterface[] = [],
    isEmptyToggle: boolean = false
  ) => {
    return (
      <div className="announcement_collapse_wrap">
        {data.map((item) => {
          const {
            noticeCode,
            noticeName,
            noticeType,
            noticeTypeValue,
            noticeStatus,
            publishTime,
            currentNotice
          } = item;
          const isItemFinished = NOTICE_SUCCESS_ARR.includes(noticeStatus);
          return (
            <div className="announcement_collapse_item" key={noticeCode}>
              <div className="item_row">
                <div
                  className={`notice_name ${currentNotice ? 'current' : ''}`}
                >
                  <Icon
                    component={() =>
                      noticeSvg(currentNotice ? '#606A76' : '#0072EF')
                    }
                    className="notice_icon"
                  />
                  <div
                    onClick={() => gotoDetailPage(item)}
                    className="notice_name-title"
                  >
                    {isEmptyToggle ? formatLabelDom(noticeName) : noticeName}
                  </div>
                </div>
                <TagsOverflow tags={item.subjectMatterNames || []} />
                {currentNotice && (
                  <div className="current_announcement">● 当前公告</div>
                )}
                {(userInfos.roleKeys === ROLE_KEYS_MAP.sales ||
                  userInfos.roleKeys === ROLE_KEYS_MAP.dealer) &&
                dataFlag === 1 &&
                !isItemFinished ? (
                  <div className="announcement-actions">
                    <ZeissButton
                      type="link"
                      danger
                      onClick={() => handleItemAction(item, 5)}
                    >
                      不相关
                    </ZeissButton>
                    <ZeissButton
                      className="btn-repeat"
                      type="link"
                      onClick={() => handleItemAction(item, 6)}
                    >
                      重复
                    </ZeissButton>
                  </div>
                ) : null}
              </div>
              <div className="item_row">
                <div>
                  <Tag className={`${noticeTypeClassMap[noticeType]}`}>
                    {noticeTypeValue}
                  </Tag>
                </div>
                <div className="time">{publishTime}</div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  useEffect(() => {
    setCollapseItemsArr(groups ?? []);
  }, [groups]);

  const formatLabelDom = (label: string = '') => {
    const keyword = inputFilterRef.current?.input?.value || '';
    let labelDom = label.replace(
      new RegExp(keyword, 'g'),
      `<span class="announcemen_header_strong">${keyword}</span>`
    );

    return <div dangerouslySetInnerHTML={{ __html: labelDom }}></div>;
  };

  // 折叠面板内容
  const collapseItemRender = (
    item: AnnouncementGroupsItemInterface,
    index: number,
    isEmptyToggle: boolean = false
  ) => {
    const { isActive, relationStatus, groupCode, groupName, notices } = item;
    const isShowBtn = notices?.length > 1;
    return (
      <div className="announcement_collapse" key={groupCode}>
        <div className="announcement_collapse_header">
          <div
            className="collapse_header_text"
            onClick={() => collapseToggle(index, isEmptyToggle)}
          >
            <Icon
              component={caretSvg}
              className={`${isActive ? '' : 'collapse-active'} collapse_icon`}
            />
            <img src={LoudspeakerIcon} alt="" style={{ marginRight: 6 }} />
            <Tooltip title={groupName}>
              <div className="collapse_header_text_label">
                {isEmptyToggle ? formatLabelDom(groupName) : groupName}
              </div>
            </Tooltip>
          </div>
          <TagsOverflow tags={item.subjectMatterNames || []} />
          {!isFinishAction && !isReturnAction && (
            <div className="announcement_operation">
              {relationStatus ? (
                isShowBtn && (
                  <ZeissButton
                    type="link"
                    danger
                    onClick={() => cancelRelation(item)}
                  >
                    取消关联
                  </ZeissButton>
                )
              ) : (
                <ZeissButton type="link" onClick={() => linkRelation(item)}>
                  关联公告组
                </ZeissButton>
              )}
            </div>
          )}
        </div>
        {isActive && collapseItemChildrenRender(notices, isEmptyToggle)}
      </div>
    );
  };

  const collapseItemContent = useMemo(() => {
    return collapseItemsArr?.map(
      (item: AnnouncementGroupsItemInterface, index: number) =>
        collapseItemRender(item, index)
    );
  }, [collapseItemsArr]);

  const handleInputSubmit = async () => {
    const keyword = inputFilterRef.current?.input?.value || '';
    // 限制为空搜索时会搜出全部公告
    if (!keyword) {
      setEmptyData([]);
      return;
    }

    const res: any = await queryRelationNotice({
      keyword,
      dataFlag
    });
    setEmptyData(res?.groups || []);
  };

  const collapseEmptyContent = useMemo(() => {
    return (
      <div className="empty_wrap">
        <div className="empty_search_wrap">
          <div>{emptyData.length ? `${emptyData.length}条搜索结果` : ''}</div>
          <ZeissInput
            placeholder="请输入公告名称、信息标题、客户单位、标的物名称进行查询"
            allowClear
            style={{ width: 440, marginRight: 20 }}
            onPressEnter={handleInputSubmit}
            ref={inputFilterRef}
            suffix={<SearchOutlined onClick={handleInputSubmit} />}
          />
        </div>

        {emptyData.length ? (
          emptyData.map(
            (item: AnnouncementGroupsItemInterface, index: number) =>
              collapseItemRender(item, index, true)
          )
        ) : (
          <Empty
            className="empty_block"
            image={<img src={EmptyIcon} width={100} alt="" />}
            description="暂无相似公告？请搜索或直接给销售"
          ></Empty>
        )}
      </div>
    );
  }, [emptyData, details]);

  const collapseToggle = (index: number, isEmptyToggle: boolean = false) => {
    const curArr = (isEmptyToggle ? emptyData : collapseItemsArr) || [];
    const newArr = curArr?.map(
      (item: AnnouncementGroupsItemInterface, i: number) => {
        if (i === index) {
          item.isActive = !item.isActive;
        }
        return item;
      }
    );
    isEmptyToggle ? setEmptyData(newArr) : setCollapseItemsArr(newArr);
  };

  const cancelRelation = async (item: AnnouncementGroupsItemInterface) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setCurrentGroupObj(item);
    setRelationActionType(ActionTypeEnum.unrelated);
    setOpen(true);
  };

  const linkRelation = async (item: AnnouncementGroupsItemInterface) => {
    const isNeedOperation = await checkNeedOperation?.();
    if (!isNeedOperation) return;
    setCurrentGroupObj(item);
    setRelationActionType(ActionTypeEnum.related);
    setOpen(true);
  };

  const onModalCancel = () => {
    setOpen(false);
    setCurrentGroupObj(null);
  };

  const onModalOk = async () => {
    setOpen(false);
    if (!currentGroupObj) return;
    const { groupCode } = currentGroupObj;
    const { noticeCode } = details;

    const res = await noticeRelation({
      groupCode,
      noticeCode,
      action: relationActionType
    });

    if (res?.dispatchSales) {
      message.success('关联的公告已经分配了销售，本公告不需要重新指派销售');
    } else {
      message.success(
        relationActionType === ActionTypeEnum.related
          ? '关联成功'
          : '取消关联成功'
      );
    }
    setCurrentGroupObj(null);
    getAnnInfo?.();
    setEmptyData([]);
  };

  const relatedAnnouncementComponent = (
    <div className="pc-related-announcement pc-new-related-announcement">
      <div className="pc-sub-tit">相关公告</div>
      <div className="pc-sub-text">{subTitle}</div>
      <div className="announcement_main">
        {groups?.length ? collapseItemContent : collapseEmptyContent}
      </div>
      <ZeissModal
        open={open}
        centered
        title={`${
          relationActionType === ActionTypeEnum.related
            ? '是否确关联?'
            : '是否确认取消关联?'
        }`}
        onCancel={onModalCancel}
        onOk={onModalOk}
      ></ZeissModal>
      <AnnFooterPopup
        getAnnInfo={getAnnInfo}
        details={details}
        noticeCode={currentNoticeObj?.noticeCode}
        actionId={actionId}
        open={repeatOpen}
        setOpen={(value: boolean) => {
          setRepeatOpen(value);
          if (!value) {
            setCurrentNoticeObj(null);
            setActionId(-1);
          }
        }}
        isAnnouncement={true}
        isDispatchAll={false}
      />
    </div>
  );
  return {
    relatedAnnouncementComponent
  };
};
